import React from 'react'
import AddDomainAddress from './AddDomainAddress'
import DNSSetting from './DNSSetting'
import SetUpWizard from './SetUpWizard'
import DNSRecords from './DNSRecords'
import Success from './Success'
import styles from '../CustomDomainModal.module.css'

const StepRenderer = ({ activeStep, formik, handlers, props }) => {
  const { handleNext, handleBack, setActiveStep, handleClose, handleCheckEntri } = handlers
  const {
    showPayWall,
    publishToCustomDomain,
    onFail,
    onSelectEntri,
    setDomains,
    refreshProfile,
    setPublishSuccessData,
    userProfile,
    modalData,
    variant = 'standard', // 'standard' or 'php'
    onCAAError,
    domains,
    onContinueSetup,
    onRetryDomain,
    onUploadToDomain
  } = props

  const isPhpFlow = variant === 'php'

  return (
    <div className={styles.content}>
      {activeStep === 0 && (
        <AddDomainAddress
          formik={formik}
          onNext={() => handleNext(formik)}
          onPrevious={handleBack}
          activeIndex={activeStep}
          setActiveStep={setActiveStep}
          isServerFile={isPhpFlow}
          domains={domains}
          onContinueSetup={onContinueSetup}
          onRetryDomain={onRetryDomain}
          onUploadToDomain={onUploadToDomain}
          handleClose={handleClose}
        />
      )}
      {activeStep === 1 && (
        <DNSSetting
          formik={formik}
          onNext={() => handleNext(formik)}
          onPrevious={handleBack}
          activeIndex={activeStep}
          handleCheckEntri={handleCheckEntri ? (payload) => handleCheckEntri(payload, formik) : undefined}
          setActiveStep={setActiveStep}
          showPayWall={showPayWall}
          publishToCustomDomain={publishToCustomDomain}
          onFail={onFail}
        />
      )}
      {activeStep === 2 && (
        <SetUpWizard
          onNext={() => handleNext(formik)}
          onPrevious={handleBack}
          formik={formik}
          activeIndex={activeStep}
          onSelectEntri={onSelectEntri}
          onFail={onFail}
          setActiveStep={setActiveStep}
          showPayWall={showPayWall}
          handleClose={handleClose}
          modalData={modalData}
        />
      )}
      {activeStep === 3 && (
        <DNSRecords
          variant={isPhpFlow ? 'php' : undefined}
          onNext={() => handleNext(formik)}
          onSelectEntri={onSelectEntri}
          onPrevious={handleBack}
          activeIndex={activeStep}
          setActiveStep={setActiveStep}
          modalData={modalData}
          updateDomains={setDomains}
          refreshProfile={refreshProfile}
          onFail={onFail}
          setPublishSuccessData={setPublishSuccessData}
          userProfile={userProfile}
          handleClose={handleClose}
          onCAAError={onCAAError}
        />
      )}
      {activeStep === 4 && (
        <Success
          formik={formik}
          onNext={() => handleNext(formik)}
          onPrevious={handleBack}
          activeIndex={activeStep}
          submit={handleClose}
          handleClose={handleClose}
          onFail={onFail}
          updateDomains={setDomains}
          onSelectEntri={onSelectEntri}
          refreshProfile={refreshProfile}
          setPublishSuccessData={setPublishSuccessData}
          userProfile={userProfile}
          onCAAError={onCAAError}
        />
      )}
    </div>
  )
}

export default StepRenderer
